import { orchestrator } from "satcheljs";
import { resetShiftStore } from "sh-shift-store";
import setShiftsInView from "../mutators/shifts/setShiftsInView";

export default orchestrator(resetShiftStore, function onResetGlobalShiftStore() {
    setShiftsInView([]);
});
